/**
 * Application Configuration
 *
 * Centralized configuration for the application.
 * All environment-specific values should be defined here.
 */

// API Configuration
// Relative base URL: the browser calls the same origin (the Vercel/dev host),
// which proxies /api to the backend. This keeps the backend host off the
// client's network path — the direct host is filtered in some countries.
// Timeout is 60s to tolerate Render free-tier cold starts (30–60s).
export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_URL || "/api/v1",
  timeout: 60000,
} as const;

// App Information
export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || "Beyond Class - Portal do Aluno",
  version: import.meta.env.VITE_APP_VERSION || "1.0.0",
} as const;

// Feature Flags
export const FEATURES = {
  enableDebugLogs: import.meta.env.DEV,
} as const;

// PIX Payment Configuration
export const PIX_CONFIG = {
  key: "contato@beyondclass.com.br",
  keyType: "email" as const,
  name: "Beyond Class Idiomas LTDA",
  qrCodeUrl:
    "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=00020126580014br.gov.bcb.pix0136contato@beyondclass.com.br5204000053039865802BR5925Beyond%20Class%20Idiomas6009SAO%20PAULO62070503***6304",
  copyPasteCode:
    "00020126580014br.gov.bcb.pix0136contato@beyondclass.com.br5204000053039865802BR5925Beyond Class Idiomas6009SAO PAULO62070503***6304E2CA",
} as const;

// Export all configs as a single object for convenience
export const config = {
  api: API_CONFIG,
  app: APP_CONFIG,
  features: FEATURES,
  pix: PIX_CONFIG,
};

export default config;
